module.exports = __webpack_public_path__ + "img/index-honor66.ed20c95f.png";